import * as XLSX from 'xlsx-js-style';

export function exportToExcel(data, fileName, sheetName) {
    if (!Array.isArray(data) || data.length === 0) {
        throw new Error("Data must be a non-empty array of objects.");
    }

    // Convert JSON data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Ensure the worksheet range is defined
    if (!worksheet['!ref']) {
        throw new Error("Worksheet range ('!ref') is undefined.");
    }

    const range = XLSX.utils.decode_range(worksheet['!ref']);

    // Apply styles to header row and convert header text to uppercase
    for (let C = range.s.c; C <= range.e.c; ++C) {
        const cellAddress = { r: 0, c: C };
        const cellRef = XLSX.utils.encode_cell(cellAddress);
        const cell = worksheet[cellRef];

        if (cell) {
            // Apply styles
            cell.s = {
                font: { bold: true, color: { rgb: '000000' } },
                fill: {
                    patternType: 'solid',
                    fgColor: { rgb: 'FFFF99' },
                },
                alignment: { vertical: 'center', horizontal: 'center', wrapText: true },
            };

            // Convert header text to uppercase if it's a string
            if (typeof cell.v === 'string') {
                cell.v = cell.v.toUpperCase();
            }
        }
    }

    // Calculate and set column widths
    const colWidths = [];

    for (let C = range.s.c; C <= range.e.c; ++C) {
        let maxWidth = 10; // Minimum width

        for (let R = range.s.r; R <= range.e.r; ++R) {
            const cellRef = XLSX.utils.encode_cell({ r: R, c: C });
            const cell = worksheet[cellRef];

            if (cell && cell.v != null) {
                const cellValue = cell.v.toString();
                const cellLength = cellValue.length;

                if (cellLength > maxWidth) {
                    maxWidth = cellLength;
                }
            }
        }

        // Convert character width to pixels (approximation)
        const widthInPixels = maxWidth * 7;
        const cappedWidth = Math.min(widthInPixels, 250); // Cap width to 250 pixels

        colWidths.push({ wpx: cappedWidth });
    }

    worksheet['!cols'] = colWidths;

    // Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);

    // Write the workbook to a file with cell styles
    XLSX.writeFile(workbook, fileName, { bookType: 'xlsx', type: 'binary', cellStyles: true });
}
